import axios from "axios";
import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { FiTrash, FiEdit } from "react-icons/fi";
import EditBTModal from "../../../components/Modals/EditBTModal";
import { notification, Popconfirm } from "antd";
import { api, endpoint } from "../../../api";

const BuildingTypeTable = ({
  data,
  getBuildingTypes,
  setPage,
  setLimit,
  total,
  limit,
  listLoading,
}) => {

  const [isLoading, setIsLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [btDataToEdit, setBtDataToEdit] = useState();
  const columns = [
    {
      name: "#",
      cell: ({ sl }) => sl,
      selector: (row) => console.log(row),
      width: "50px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
    },
    {
      name: "Action",
      cell: (row) => (
        <div>
          <button className="btn btn-info me-1" onClick={() => editType(row)}>
            <FiEdit />
          </button>
          <Popconfirm
            title="Are you sure?"
            okButtonProps={{
              className: "btn btn-danger",
              loading: isLoading,
            }}
            onConfirm={() => {
              deleteType(row._id);
            }}
          >
            <button className="btn btn-danger">
              <FiTrash />
            </button>
          </Popconfirm>
        </div>
      ),
      width: '150px',
      center: "yes",
    },
  ];
  const editType = (data) => {
    setBtDataToEdit(data);
    setModalShow(true);
  };
  const deleteType = async (id) => {
    setIsLoading(true);
    try {
      const { message } = await api.delete(endpoint.delete_building_type + id);
      notification.success({ message, placement: "bottomLeft" });
      getBuildingTypes();
    } catch (error) {
      notification.warning({
        message: "Something went wrong.",
        placement: "bottomLeft",
      });
    }
    setIsLoading(false);
  };
  return (
    <div>
      <h4 className="mb-2">Building Types</h4>
      <DataTable
        columns={columns}
        data={data}
        pagination
        paginationServer
        noDataComponent={listLoading ? "Loading" : "No record found."}
        paginationTotalRows={total}
        paginationPerPage={limit}
        onChangePage={(data) => {
          setPage(data);
        }}
        onChangeRowsPerPage={(data) => {
          setLimit(data);
          setPage(1);
        }}
        paginationRowsPerPageOptions={[10, 20, 50]}
      />
      <EditBTModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        btDataToEdit={btDataToEdit}
        setModalShow={setModalShow}
        getBuildingTypes={getBuildingTypes}
      />
    </div>
  );
};

export default BuildingTypeTable;
